import React from 'react';
import Modal from '../common/Modal';
import { STATUSES } from '../../utils/orderUtils';

export default function StatusUpdateModal({ state, setState, onSave }) {
  return (
    <Modal
      open={state.open}
      onClose={() => setState({ open: false })}
      title="Update Order Status"
      footer={<>
        <button className="btn btn-secondary" onClick={() => setState({ open: false })}>Cancel</button>
        <button className="btn btn-primary" onClick={onSave}>Update</button>
      </>}
    >
      {state.order && (
        <div className="form-group">
          <label className="form-label">New Status for {state.order.order_number}</label>
          <select className="form-control form-select"
            value={state.status}
            onChange={e => setState(p => ({ ...p, status: e.target.value }))}>
            {STATUSES.filter(s => s !== 'revised').map(s => (
              <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
            ))}
          </select>
        </div>
      )}
    </Modal>
  );
}
